module.exports = __webpack_public_path__ + "static/media/step4.c25aa41c.png";